<template>
  <div class="home p-8 h-screen flex items-center justify-center">
    <VPLogo />
  </div>
</template>

<script>
import VPLogo from '@/assets/images/VP-Logo.svg'

export default {
  name: 'Home',
  components: {
    VPLogo,
  },
}
</script>
